import { useEffect, useState } from "react";
import SelectBox from "../../../../../utils/components/SelectBox";

const StepStatus = ({
  step,
  statusSets,
  stepsList,
  handleAction,
  translate,
  workflowType,
}) => {
  const [stepStatus, setStepStatus] = useState({});
  const [isFirstStep, setIsFirstStep] = useState(false);

  useEffect(() => {
    if (stepsList?.length > 0) {
      const index = stepsList.findIndex((item) => item.id === step.step_code);
      if (index === 0) setIsFirstStep(true);
    }
  }, [stepsList, step]);

  const handleSelectChange = ({ value, setId, type }) => {
    const newStepStatus = { ...stepStatus };
    const key = setId.toString();

    if (!newStepStatus[key])
      newStepStatus[key] = {
        status_set_id: setId,
      };

    if (type === "accept_id") {
      const rejectId = newStepStatus[key].reject_id;
      if (rejectId === value) newStepStatus[key].reject_id = null;
    }

    if (type === "reject_id") {
      const acceptId = newStepStatus[key].accept_id;
      if (acceptId === value) newStepStatus[key].accept_id = null;
    }

    newStepStatus[key][type] = value;
    setStepStatus(newStepStatus);
  };

  const findStatus = (value, item) => {
    if (value) {
      const status = item.details.find((item) => item.id === value);
      if (status)
        return {
          value: status.id,
          label: status.name,
        };
    }
    return null;
  };

  useEffect(() => {
    if (step.settings.step_statuses) {
      const newStepStatus = {};
      step.settings.step_statuses.forEach((item) => {
        newStepStatus[item.status_set_id] = item;
      });
      setStepStatus(newStepStatus);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    handleAction("step_status", stepStatus);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stepStatus]);

  return (
    <div>
      <div className="col-12 d-flex align-items-center border-bottom pb-2">
        <div className="col-3">
          <p className="text-gray text-uppercase fw-bold mb-2">
            {translate("design_approval_process.step-edit-modal.status-set")}
          </p>
        </div>
        <div className="col-4 ms-2">
          <p className="text-gray text-uppercase fw-bold mb-2">
            {translate("design_approval_process.step-edit-modal.accept")}
          </p>
        </div>
        {(!isFirstStep || workflowType === "manual") && (
          <div className="col-3 ms-2">
            <p className="text-gray text-uppercase fw-bold mb-2">
              {translate("design_approval_process.step-edit-modal.reject")}
            </p>
          </div>
        )}
      </div>
      {statusSets?.map((item, index) => (
        <div className="row py-3 border-bottom" key={index}>
          <div className="col-3 d-flex align-items-center justify-content-start">
            {item.name}
          </div>
          <div className="col-4">
            <SelectBox
              options={item.details.map((opt) => {
                return {
                  value: opt.id,
                  label: opt.name,
                };
              })}
              onChange={(data) =>
                handleSelectChange({
                  value: data.value,
                  setId: item.id,
                  type: "accept_id",
                  index,
                })
              }
              value={findStatus(stepStatus[item.id]?.accept_id, item)}
              placeholder={translate(
                "design_approval_process.step-edit-modal.select-status"
              )}
            />
          </div>
          {(!isFirstStep || workflowType === "manual") && (
            <div className="col-4">
              <SelectBox
                options={item.details.map((opt) => {
                  return {
                    value: opt.id,
                    label: opt.name,
                  };
                })}
                onChange={(data) => {
                  handleSelectChange({
                    value: data.value,
                    setId: item.id,
                    type: "reject_id",
                    index,
                  });
                }}
                value={findStatus(stepStatus[item.id]?.reject_id, item)}
                placeholder={translate(
                  "design_approval_process.step-edit-modal.select-status"
                )}
              />
            </div>
          )}
        </div>
      ))}
    </div>
  );
};
export default StepStatus;
